import {getStore} from '@/store/root-store';
import {Userpilot} from 'userpilot';

// Get token from environment variables instead of hardcoding
const USERPILOT_TOKEN = process.env.NEXT_PUBLIC_USERPILOT_TOKEN || '';

// Utility to check if we're in a production environment
const isProduction = () => {
  if (typeof window === 'undefined') return false;

  const store = getStore();
  const {settings: {customer: {isGHLAccount}}} = store;

  return process.env.NODE_ENV === 'production' && USERPILOT_TOKEN && isGHLAccount === false;
};

// Create a wrapper for Userpilot that only runs in production
const userpilot = {
  initialize: () => {
    if (isProduction()) {
      Userpilot.initialize(USERPILOT_TOKEN);
    } else {
      console.debug('[Userpilot] Initialize called with token:', USERPILOT_TOKEN);
    }
  },
  identify: (userId, traits = {}) => {
    if (isProduction()) {
      Userpilot.identify(userId, traits);
    } else {
      console.debug('[Userpilot] Identify called for user:', userId, 'with traits:', traits);
    }
  },
  reload: () => {
    if (isProduction()) {
      Userpilot.reload();
    } else {
      console.debug('[Userpilot] Reload called');
    }
  },
  track: (eventName, properties = {}) => {
    if (isProduction()) {
      Userpilot.track(eventName, properties);
    } else {
      console.debug('[Userpilot] Track called for event:', eventName, 'with properties:', properties);
    }
  },
};

export default userpilot;
